import { Reducers, ReduxReusableComponents, RRCProps, State } from "@crispico/foundation-react/reduxReusableComponents/ReduxReusableComponents";
import React from "react";
import Interweave from "interweave";
import { Modal, Button } from "semantic-ui-react";
import { ModalExt, Severity } from "@crispico/foundation-react/components/ModalExt/ModalExt";
import { mission2Service_checkMissionValidationVariables as MissionValidationParam } from "apollo-gen/mission2Service_checkMissionValidation";
import { apolloClientHolder } from "@crispico/foundation-react/apolloClient";
import { MISSION_CHECK_MISSION_VALIDATION } from "./queries";
import { Utils } from "@crispico/foundation-react";

const MUTATION_DATA = "mission2Service_checkMissionValidation";

export class MissionValidationState extends State {
    open: boolean = false;
    message?: string;
    severity?: Severity;
}

export class MissionValidationReducers<S extends MissionValidationState = MissionValidationState> extends Reducers<S> {
    close() {
        this.s.open = false;
        this.s.message = undefined;
        this.s.severity = undefined;
    }
};

export enum MissionValidationMessageCheckType { ERROR = "ERROR", MESSAGE = "MESSAGE" }

type PropsNotFromState = {
    // Called if no errors/warnings found by the validation.
    validationPassedHandler?: () => void
    // Modal actions handlers.
    okHandler?: () => void
    cancelHandler?: () => void
}
type Props = RRCProps<MissionValidationState, MissionValidationReducers> & PropsNotFromState

export class MissionValidation extends React.Component<Props> {

    // This method should be called from the parent component via ref.
    async checkMissionValidation(param: MissionValidationParam) {
        const result: string[] = (await apolloClientHolder.apolloClient.mutate({ mutation: MISSION_CHECK_MISSION_VALIDATION, variables: param })).data[MUTATION_DATA] as [];
        if (!Utils.isNullOrEmpty(result) && !Utils.isNullOrEmpty(result[0]) && !Utils.isNullOrEmpty(result[1])) {
            this.props.r.setInReduxState({ open: true, message: result[1], severity: result[0] == MissionValidationMessageCheckType.MESSAGE ? Severity.WARNING : Severity.ERROR });
            return;
        }
        this.props.validationPassedHandler?.();
    }

    protected onOkHandler() {
        this.props.okHandler?.();
        this.props.r.close();
    }

    protected onCancelHandler() {
        this.props.cancelHandler?.();
        this.props.r.close();
    }

    render(): React.ReactNode {
        return <ModalExt className="wh-auto" severity={this.props.s.severity} open={this.props.s.open} onClose={() => this.props.r.close()}>
            <Modal.Content>
                <Modal.Description>
                    <Interweave content={this.props.s.message} />
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                {this.props.s.severity == Severity.WARNING && <Button primary content={_msg("general.ok")} onClick={() => this.onOkHandler()} />}
                <Button content={_msg("general.cancel")} onClick={() => this.onCancelHandler()} />
            </Modal.Actions>
        </ModalExt>
    }
}

export const MissionValidationRRC = ReduxReusableComponents.connectRRC(MissionValidationState, MissionValidationReducers, MissionValidation)